<template>
	<div class="px-0">
		<div class="d-flex align-center justify-space-between my-1">
			<h4 class="my-0 text-primary">Observaciones Generales ITO</h4>
			<v-btn
				v-if="currentAdicional.userprojectjobtype.job_type_id === 4"
				class="mx-2 my-0"
				rounded
				color="warning"
				dark
				x-small
				@click="showAddObservation = true"
			>
				<v-icon dark small>mdi-comment-plus-outline</v-icon>
				<p class="mb-0 ml-2">Agregar Observación</p>
			</v-btn>
		</div>
		<div v-if="!interactions || interactions.length === 0" class="d-flex align-center justify-center" style="height: 40px;">
			<div class="d-flex align-center text-center" style="gap: 10px;">
				<v-icon size="20" color="#cfd8dc">mdi-comment-text-multiple-outline</v-icon>
				<p class="mb-0 text--disabled">Sin observaciones</p>
			</div>
		</div>
		<Interactions
			itemType="additional_general_interactions"
			:interactions="interactions"
			:item="currentAdicional"
			@reload="reloadInfo"
			@reply-interaction="onReplyInteraction"
			@minimizeParent="() => $emit('minimizeParent')"
			:beforeNavigate="beforeAssocNavigate"
		/>
		<div v-show="showAddObservation">
			<v-divider class="my-2"></v-divider>
			<!-- Banner: respondiendo a interacción padre -->
			<v-row align="center" v-if="interactionParent">
				<v-col cols="12">
					<div class="reply-banner d-flex align-center justify-space-between px-3 py-2">
						<div class="d-flex align-center">
							<v-icon size="16" color="#2D4B95" class="mr-2">mdi-reply</v-icon>
							<div>
								<span class="caption font-weight-bold text-primary">
									Respondiendo a {{ interactionParent.user ? interactionParent.user.name : '' }}
								</span>
								<div
									v-html="interactionParent.message"
									class="reply-preview caption text--disabled"
								></div>
							</div>
						</div>
						<v-btn icon x-small @click="clearReply">
							<v-icon size="16">mdi-close</v-icon>
						</v-btn>
					</div>
				</v-col>
			</v-row>

			<!-- Diálogo: modo de visualización de la respuesta -->
			<v-dialog v-model="replyModeDialog" max-width="420" persistent>
				<v-card>
					<v-card-title class="subtitle-1 font-weight-bold text-primary pb-1">
						¿Cómo mostrar tu respuesta?
					</v-card-title>
					<v-card-text>
						<p class="body-2 mb-3">
							Puedes elegir cómo aparecerá tu respuesta en la conversación:
						</p>
						<v-radio-group v-model="replyShowInFeed" hide-details>
							<v-radio :value="true" color="#2D4B95">
								<template v-slot:label>
									<div>
										<p class="mb-0 body-2 font-weight-medium">Como mensaje nuevo al final</p>
										<p class="mb-0 caption text--disabled">
											Aparece al final de la conversación indicando a qué mensaje responde
										</p>
									</div>
								</template>
							</v-radio>
							<v-divider class="my-2"></v-divider>
							<v-radio :value="false" color="#2D4B95">
								<template v-slot:label>
									<div>
										<p class="mb-0 body-2 font-weight-medium">Solo como subrespuesta directa</p>
										<p class="mb-0 caption text--disabled">
											Aparece anidada dentro del mensaje original, sin ocupar espacio al final
										</p>
									</div>
								</template>
							</v-radio>
						</v-radio-group>
					</v-card-text>
					<v-card-actions class="pt-0 pb-3 px-4">
						<v-spacer/>
						<v-btn text small @click="cancelReplyMode">Cancelar</v-btn>
						<v-btn small color="#2D4B95" dark rounded @click="confirmReplyMode">Confirmar</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>
			<InteractionEditor
				v-model="newObservation"
				item_type="additional_general_observation"
				:item="currentAdicional"
				@paste-image="onPasteImage"
				@mentions-updated="onMentionsUpdated"
			/>
			<div class="mt-2" v-if="filesPreview.length > 0">
				<div class="attach-toggle" @click="showAttachments = !showAttachments">
					<span class="attach-dot"></span>
					<span class="attach-label">
						{{ filesPreview.length }} {{ filesPreview.length === 1 ? 'adjunto' : 'adjuntos' }}
					</span>
					<v-icon small :class="['attach-chevron', { open: showAttachments }]">
						mdi-chevron-down
					</v-icon>
				</div>
				<div v-if="showAttachments" class="attach-panel">
					<div class="attach-grid">
						<div
							v-for="(file, index) in filesPreview.filter(f => f.src)"
							:key="'img-' + index"
							class="img-chip"
						>
							<img :src="file.src" class="img-thumb" />
							<button class="chip-remove" @click="removeAttachment(file, index)">
								<v-icon x-small color="white">mdi-close</v-icon>
							</button>
						</div>
						<div
							v-for="(file, index) in filesPreview.filter(f => !f.src)"
							:key="'file-' + index"
							class="file-chip"
						>
							<v-icon small color="#5E85EF">mdi-file-outline</v-icon>
							<span class="file-name">{{ file.name }}</span>
							<button class="chip-remove file" @click="removeAttachment(file, index)">
								<v-icon x-small>mdi-close</v-icon>
							</button>
						</div>

					</div>
				</div>
			</div>
			<div class="d-flex justify-end align-center my-2">
				<v-btn
					class="mx-2 my-1"
					rounded
					color="#2D4B95"
					raised
					text
					@click="cancelAddObservation"
				>
					<p class="mb-0 text-primary">Cancelar</p>
				</v-btn>
				<v-btn
					class="mx-2 my-1"
					rounded
					color="white"
					raised
					@click="onButtonClick"
				>
					<p class="mb-0 text-primary">Adjuntar Archivo</p>
				</v-btn>
				<input
					ref="uploaderRevisionObservation"
					class="d-none"
					type="file"
					@change="onFileChanged"
				>
				<v-btn
					class="mx-2 my-1"
					rounded
					color="white"
					raised
					:class="{ canceling: inCancelTime }"
					:disabled="!inCancelTime && (!newObservation || newObservation.length == 0)"
					@click="preConfirmAddObservation"
				>
					<p class="mb-0 text-primary">{{ confirmButtonText }}</p>
				</v-btn>
			</div>
		</div>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import _debounce from 'lodash/debounce'
import EventBus from '@/helpers/event_bus'
import {getPublicUrl} from '@/helpers/api/tasks'
import {addInteraction} from '@/helpers/api/additionals'
import {deleteFile} from '@/helpers/api/fileManager'
import {create as createDraftAPI, update as updateDraftAPI} from '@/helpers/api/drafts'
import Interactions from '@/components/Globals/Helpers/Interactions'
import InteractionEditor from '@/components/Globals/Helpers/InteractionEditor'

export default {
	name: 'AdditionalGeneralObservations',
	components: {Interactions, InteractionEditor},
	props: {
		additional: {
      type: Object,
      required: true
    },
		needToReloadListing: {
			type: Function,
			required: false,
			default: null
		},
		beforeNavigate: {
			type: Function,
			required: false,
			default: null
		}
	},
	computed: {
    currentAdicional() {
      return this.$store.adicionalesStore.state.currentAdicional
    },
		interactions(){
			return this.additional.interactions
		},
		draftToLoad(){
			return this.$store.adicionalesStore.state.draftToLoad
		}
	},
	watch: {
		interactions(newValue){
			if(newValue.length > 0){
				this.$nextTick(() => {
					const container = this.$refs.observationScroll;
					if (container) {
						container.scrollTop = container.scrollHeight;
					}
				})
			}
		},
    newObservation(val) {
      if(val && val.length > 0) {
        this.handleFormChangeDebounced()
      }
    },
    files() {
      this.handleFormChangeDebounced()
    },
		showAddObservation(val){
			if(val){
				this.$nextTick(() => {
					this.$emit('scrollToAddObservation')
				})
			}
		},
		draftId(newVal){
			this.$emit('draftIdSet', newVal)
		}
	},
	data: () => ({
		loadingFilePath: false,
		showAttachmentsId: null,
		showAttachments: true,
		showAddObservation: false,
		newObservation: null,
		cancelTimer: 4,
		inCancelTime: false,
		cancelInterval: null,
		confirmButtonText: 'Confirmar',
    files: [],
    filesPreview: [],
		draftId: null,
		draftCreated: false,
		draftUpdateInterval: 20,
		draftSaveTimer: null,
		draftCreationPromise: null,
		handleFormChangeDebounced: null,
		isResetting: false,
		interactionParent: null,
		replyModeDialog: false,
		replyShowInFeed: true,
		newInteractionMentions: []
	}),
	mounted(){
		this.$nextTick(() => {
			const container = this.$refs.observationScroll;
			if (container) {
				container.scrollTop = container.scrollHeight;
			}
		})
    this.setListeners()
    this.handleFormChangeDebounced = _debounce(() => this.checkAndCreateDraft(), 1000)
		if(this.draftToLoad){
			this.loadDraft(this.draftToLoad)
		}
	},
	beforeDestroy(){
		EventBus.$off('completedFileUpload')
		if(this.draftSaveTimer){
			clearInterval(this.draftSaveTimer)
			this.draftSaveTimer = null
		}
		if(this.cancelInterval){
			clearInterval(this.cancelInterval)
			this.cancelInterval = null
		}
		this.updateDraft()
	},
	methods: {
		async beforeAssocNavigate () {
			if (!this.draftId && this.newObservation && this.newObservation.trim()) await this.createDraft()
			if (this.draftId) await this.updateDraft()
			if (this.beforeNavigate) return this.beforeNavigate(this.draftId)
			this.$emit('minimizeParent', this.draftId)
		},
		onMentionsUpdated (userIds) {
			this.newInteractionMentions = userIds
		},
		onReplyInteraction (interaction) {
			this.interactionParent = interaction
			this.replyModeDialog = true
			if (!this.showAddObservation) {
				this.showAddObservation = true
			}
		},
		confirmReplyMode () {
			this.replyModeDialog = false
		},
		cancelReplyMode () {
			this.replyModeDialog = false
			this.interactionParent = null
			this.replyShowInFeed = true
		},
		clearReply () {
			this.interactionParent = null
			this.replyShowInFeed = true
		},
		reloadInfo(){
			this.$store.adicionalesStore.dispatch('getAdditionalByID', {
				additional_id: this.additional.id,
				seen_by_me: true,
				dontSetLoading: true
			})
		},
		async onPasteImage(file){
			await this.createDraft(true)
			this.onFileChanged(null, file)
		},
    setListeners(){
      EventBus.$on('completedFileUpload', async (payload) => {
        if(payload && payload.draft_id === this.draftId){
          const findIndex = this.filesPreview.findIndex((file) => file.uuid === payload.uuid)
          if(findIndex !== -1){
            this.$set(this.filesPreview[findIndex], 'id', payload.file.id)
          }
        }
        else if(payload && payload.additional_id && this.currentAdicional && payload.additional_id == this.currentAdicional.id){
					this.$store.adicionalesStore.dispatch('getAdditionalByID', {
						additional_id: this.additional.id,
						seen_by_me: true,
						dontSetLoading: true
					})
        }
      })
    },
    hasObservationAttachments(observation) {
      return observation.attachments.some(item => item.file.pathmedia)
    },
    observationAttachments(observation) {
      return observation.attachments
        .filter(item => item.file.pathmedia)
        .map(item => item.file.pathmedia)
    },
    setClassInteraction(interaction){
      let final_class = this.isMyInteraction(interaction.user) ? 'right':'left'
      final_class += interaction.is_response ? ' response':''
      return final_class
    },
    isMyInteraction(observationUser){
      return observationUser.id == this.$store.userStore.state.userInfo.id
    },
		cancelAddObservation(){
			if(this.cancelInterval){
				clearInterval(this.cancelInterval)
				this.cancelInterval = null
			}
			this.inCancelTime = false
			this.confirmButtonText = 'Confirmar'
			this.showAddObservation = false
			this.newObservation = ''
			this.interactionParent = null
			this.replyShowInFeed = true
			this.newInteractionMentions = []
			this.draftId = null
			this.draftCreated = false
			this.files = []
			this.filesPreview = []
			if(this.draftSaveTimer){
				clearInterval(this.draftSaveTimer)
				this.draftSaveTimer = null
			}
		},
		preConfirmAddObservation(){
			if(this.inCancelTime){
				clearInterval(this.cancelInterval)
				this.cancelInterval = null
				this.confirmButtonText = 'Confirmar'
				this.inCancelTime = false
				return null
			}
			if(!this.newObservation || this.newObservation === ''){
				this.$store.globalStore.dispatch('addMessage', {
					message: 'Por favor escribe una observación.',
					title: 'Error',
					created: new Date(),
					type: 'success',
					icon: 'mdi-alert-circle',
					color: '#fb8c00'
				})
				return false
			}
			this.startObservationCountdown()
		},
		startObservationCountdown(){
			this.inCancelTime = true
			this.cancelTimer = 4
			this.confirmButtonText = `Cancelar (${this.cancelTimer})`
			this.cancelInterval = setInterval(() => {
				this.cancelTimer--
				this.confirmButtonText = `Cancelar (${this.cancelTimer})`
				if(this.cancelTimer == 0){
					this.inCancelTime = false
					this.confirmButtonText = 'Confirmar'
					clearInterval(this.cancelInterval)
					this.cancelInterval = null
					this.confirmAddObservation()
				}
			}, 1000)
		},
		async confirmAddObservation(){
			const data = {
				additional_id: this.additional.id,
				message: this.newObservation,
				draft_id: this.draftId
			}
			if (this.interactionParent) {
				data.parent_id = this.interactionParent.id
				data.show_in_feed = this.replyShowInFeed ? 1 : 0
			}
			if (this.newInteractionMentions.length > 0) {
				data.mentions = this.newInteractionMentions
			}
			const observation = await addInteraction(data)
			let datas = null
			if(observation.code == 200){
				datas = {
					message: 'Se ha agregado la interacción',
					title: 'Ok',
					created: new Date(),
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3'
				}
				this.interactionParent = null
				this.replyShowInFeed = true
				this.newInteractionMentions = []
				this.cancelAddObservation()
				if(this.needToReloadListing) this.needToReloadListing()
				this.$store.adicionalesStore.dispatch('getAdditionalByID', {
					additional_id: this.additional.id,
					seen_by_me: true,
					dontSetLoading: true
				})

				const biggerFiles = []
				this.files.forEach((file) => {
					biggerFiles.push({
						type: 15,
						payload: null,
						total: file.size,
						uuid: uuidv4(),
						file
					})
				})
				if(biggerFiles.length > 0){
					biggerFiles.map(file => {
						file.item_id = this.additional.id
						file.payload = {
							additional_id: this.additional.id,
							additional_interaction_id: observation.new_interaction.id,
							project_id: this.$store.projectsStore.state.selectedProject.id
						}
						this.$store.globalStore.commit('setFilesToUploadCenter', file)
					})
				}
			}
			else{
        datas = {
					message: 'Hubo un error por favor intenta nuevamente.',
					title: 'Error',
					created: new Date(),
					type: 'warning',
					icon: 'mdi-alert-circle',
					color: '#fb8c00'
        }
			}
			this.$store.globalStore.dispatch('addMessage', datas)
		},
    async getFilesUrl(attachments, singleFile = false, download = false){
      if(singleFile){ attachments = [attachments] }
      this.loadingFilePath = true
      const files = await getPublicUrl({attachments, force_download: download})
      if(files.code === 200){
        files.files.forEach((file) => {
          window.open(file.url);
        })
      }
      this.loadingFilePath = false
    },
		handleShowAttachments(observation){
			if(this.showAttachmentsId == observation.id){
				this.showAttachmentsId = null
			}
			else{
				this.showAttachmentsId = observation.id
			}
		},
    onButtonClick() {
      this.$refs.uploaderRevisionObservation.click()
    },
		async onFileChanged(e, file = null) {
			const newFile = e?.target?.files[0] || file
			if(!newFile) return
      if (!this.draftId && !this.draftCreated) await this.createDraft(true)

      const uuid = uuidv4()
      if(newFile.type.includes('image')){
        const base64File = await this.toBase64(newFile)
        this.filesPreview.push({src: base64File, name: newFile.name, uuid})
      }
      else{
        this.filesPreview.push({noImage: true, name: newFile.name, uuid})
      }
      
      const fileToUpload = {
        type: 13,
        payload: {draft_id: this.draftId, project_id: this.$store.projectsStore.state.selectedProject.id, uuid},
        description: this.currentAdicional.title,
        total: newFile.size,
        uuid,
        file: newFile
      }
      this.$store.globalStore.commit('setFilesToUploadCenter', fileToUpload)
    },
		removeAttachment(file, index){
			this.filesPreview.splice(index, 1)
			if(file.id){
				deleteFile({file_id: file.id})
			}
		},
    toBase64(file) {
      return new Promise((resolve) => {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          resolve(reader.result)
        };
        reader.onerror = function () {
          resolve(null)
        };
      })
    },
    handleFormChange(){
      if(!this.isResetting && this.handleFormChangeDebounced){
        this.handleFormChangeDebounced()
      }
    },
    checkAndCreateDraft(){
      if(!this.draftCreated && !this.draftId){
        this.createDraft()
      }
    },
    async createDraft(force_create = false){
			if(this.draftId) return this.draftId
			if(this.draftCreated) return this.draftCreationPromise
      if ((!this.newObservation || this.newObservation.trim() === '') && !force_create) return null
      this.draftCreated = true
      
      const draftData = {
        type: 10,
				project_id: this.$store.projectsStore.state.selectedProject.id,
        type_id: this.currentAdicional.id,
        data: JSON.stringify({
          newObservation: this.newObservation,
					title: this.currentAdicional.title,
					number: this.currentAdicional.number
        })
      }
      
      try {
				this.draftCreationPromise = createDraftAPI(draftData)
				const response = await this.draftCreationPromise
        if(response.code === 200){
					this.draftId = response.draft.id
          this.startDraftUpdateTimer()
					EventBus.$emit('reloadDraftList')
					return this.draftId
        }
      } catch (error) {
        console.error('Error creating draft:', error)
        this.draftCreated = false
				throw error
			} finally {
			this.draftCreationPromise = null
      }
    },
    startDraftUpdateTimer(){
      if(this.draftSaveTimer){
        clearInterval(this.draftSaveTimer)
        this.draftSaveTimer = null
      }
      
      this.draftSaveTimer = setInterval(() => {
        this.updateDraft()
      }, this.draftUpdateInterval * 1000)
    },
    async updateDraft(){
      if(!this.draftId) return
      
      const draftData = {
        id: this.draftId,
        type: 10,
				project_id: this.$store.projectsStore.state.selectedProject.id,
        type_id: this.currentAdicional.id,
        data: JSON.stringify({
          newObservation: this.newObservation,
					title: this.currentAdicional.title,
					number: this.currentAdicional.number
        })
      }
      
      try {
        await updateDraftAPI(draftData)
      } catch (error) {
        console.error('Error updating draft:', error)
      }
    },
    async loadDraft(draft){
			console.log('Loading draft:', draft) // --- IGNORE ---
			if(draft && draft.data){
				this.isResetting = true
				this.newObservation = draft.data.newObservation || ''

				try{
					const filePreviews = []
					
					if(draft.files && Array.isArray(draft.files)){
						for(const file of draft.files){
							if(file.mime_type && file.mime_type.includes('image')){
								if(file.pathmedia?.path){
									filePreviews.push({src: file.pathmedia.path, id: file.id, name: file.name})
								}
								else{
									filePreviews.push({noImage: true, id: file.id, name: file.name})
								}
							}
							else{
								filePreviews.push({noImage: true, id: file.id, name: file.name})
							}
						}
					}
					this.filesPreview = filePreviews
				}
				catch(error){
					console.error('Error al cargar archivos del draft:', error)
				}
				
				this.draftId = draft.id
				this.draftCreated = true
				this.showAddObservation = true
				this.startDraftUpdateTimer()

				this.$nextTick(() => {
					this.isResetting = false
				})

				const data = {
					message: 'Borrador cargado correctamente. Los cambios se guardarán automáticamente.',
					title: 'Borrador Cargado',
					created: new Date(),
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3'
				}
				this.$store.globalStore.dispatch('addMessage', data)
				this.$store.adicionalesStore.commit('setDraftToLoad', null)
			}
    },
	}
}
</script>

<style scoped>
	.observations-container{
		max-height: 300px;
		overflow-y: scroll;
	}
	.interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .interaction-container.response{
    background-color: #CAE7CC;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
	.text-primary{color: #2D4B95;}
  .light-blue-text{color: #5E85EF;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  .preview-img-container{
    position: relative;
  }
  .preview-img{
    width: 50px;
    height: 50px;
    border-radius: 10px;
    object-fit: contain;
  }
  .button-preview-img{
    position: absolute;
    top: -1px;
    left: -1px;
    background-color: white;
  }

	.attach-toggle {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		padding: 4px 10px;
		border: 1px solid rgba(0,0,0,0.15);
		border-radius: 8px;
		background: #f5f5f5;
		font-size: 13px;
		color: #666;
		cursor: pointer;
		user-select: none;

		&:hover { background: #ebebeb; }
		.attach-dot { width: 6px; height: 6px; border-radius: 50%; background: #5E85EF; }
		.attach-chevron { transition: transform 0.18s; &.open { transform: rotate(180deg); } }
	}

	.attach-panel {
		margin-top: 8px;
		padding: 10px;
		border: 1px solid rgba(0,0,0,0.08);
		border-radius: 8px;
	}

	.attach-grid { display: flex; flex-wrap: wrap; gap: 8px; }

	.img-chip {
		position: relative;
		width: 64px;
		height: 64px;
		border-radius: 8px;
		overflow: hidden;
		border: 1px solid rgba(0,0,0,0.1);
		flex-shrink: 0;

		.img-thumb { width: 100%; height: 100%; object-fit: cover; display: block; }
		.chip-remove {
			position: absolute;
			top: 2px; right: 2px;
			width: 18px; height: 18px;
			border-radius: 50%;
			background: rgba(0,0,0,0.5);
			border: none;
			display: flex; align-items: center; justify-content: center;
			cursor: pointer;
		}
	}

	.file-chip {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		padding: 5px 8px;
		border: 1px solid rgba(0,0,0,0.1);
		border-radius: 8px;
		background: #f5f5f5;
		font-size: 13px;
		max-width: 200px;

		.file-name { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex: 1; }
		.chip-remove.file {
			width: 18px; height: 18px;
			border-radius: 50%;
			background: #e0e0e0;
			border: none;
			display: flex; align-items: center; justify-content: center;
			cursor: pointer;
			flex-shrink: 0;
		}
	}
	.reply-banner {
		background-color: #EEF2FF;
		border-left: 3px solid #2D4B95;
		border-radius: 0 6px 6px 0;
		font-size: 13px;
	}
	.reply-preview {
		max-height: 20px;
		max-width: 400px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	.reply-preview * {
		display: inline;
	}
</style>